import React from 'react';
import Typography from '@material-ui/core/Typography';
import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
import { TooltipProps } from 'recharts';
import { format } from 'date-fns';

import { formatOrderCount } from 'features/dashboard/utils/formatOrderCount';
import { useStyles } from './styles';

export type CustomTooltipProps = TooltipProps<ValueType, NameType> & {
  tooltipFormatter?: (date: Date) => string;
};

const defaultTooltipFormatter = (date: Date) => format(date, 'MMMM dd yyyy');

export const CustomTooltip = ({
  active,
  payload,
  label,
  tooltipFormatter = defaultTooltipFormatter,
}: CustomTooltipProps) => {
  const classes = useStyles();
  if (!active) return null;

  const formattedLabel = label === 'auto' ? '' : tooltipFormatter(label);

  return (
    <div className={classes.tooltip}>
      <Typography variant="h6" className={classes.ordersCountLabel}>
        {formatOrderCount((payload && (payload[0]?.value as number)) || 0)}
      </Typography>
      <Typography variant="subtitle2" className={classes.dateLabel}>
        {formattedLabel}
      </Typography>
    </div>
  );
};
